<div class="layout-topbar pb-0 pl-2">
  <div class="flex justify-content-between h-full">
    <div class="flex align-items-center">
      <a [routerLink]="'/'">
        <img [src]="icon ? icon : 'zmx-white.png'"
             alt="Zumex" id="topbar-logo">
      </a>
      <div (click)="switchMenu()" class="ml-3 cursor-pointer">
        <a class="icon-white"><i class="pi pi-bars topbar-icon"></i></a>
      </div>
    </div>
    <div class="flex align-items-center h-full">
      <p-avatar (click)="op.show($event)" [style.margin-bottom]="'2px'" class="cursor-pointer mr-2" icon="pi pi-user"
                pRipple shape="circle" styleClass="topbar-avatar"></p-avatar>
      <p-overlayPanel #op>
        <ng-template pTemplate>
          <div class="flex flex-column user-overlay" style="min-height: 50px">
            <div class="flex flex-column sm:flex-row justify-content-between" style="min-height: 50px">
              <div class="flex flex-column ml-2">
                <p *ngIf="userData.name" class="py-0 mt-0 bold" style="margin-bottom: 6px">{{userData.name}}</p>
                <p class="py-0 mt-0" style="margin-bottom: 6px">{{userData.username}}</p>
                <p class="py-0 mt-0">{{userData.email}}</p>
              </div>
              <p-divider class="hidden sm:block mx-3" layout="vertical"></p-divider>
              <p-divider class="sm:hidden block mx-3" layout="horizontal"></p-divider>
              <div class="flex flex-column sm:justify-content-between sm:text-right sm:align-items-end">
                <div class="flex align-items-center pt-1">
                  <a href="/account" class="sm:my-0 mr-2 ml-2 sm:ml-0 bold">
                    {{'common.myAccount' | transloco}}
                  </a>
                </div>
                <p (click)="logout()" class="cursor-pointer py-0 mt-2 sm:my-0 mr-2 ml-2 sm:ml-0 bold">
                  {{'common.logout' | transloco}}
                </p>
              </div>
            </div>
          </div>
        </ng-template>
      </p-overlayPanel>
    </div>
  </div>
</div>

